import { Component, DestroyRef, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { from } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DocumentUploadDialogDirective } from './document-upload-dialog.directive';

interface DialogData {
  headline: string;
}

@Component({
  selector: 'admin-app-document-upload-dialog',
  templateUrl: './document-upload-dialog.component.html',
  styleUrls: ['document-upload-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocumentUploadDialogComponent implements OnInit {
  data = inject<DialogData>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<DocumentUploadDialogComponent>>(MatDialogRef);
  private destroyRef = inject(DestroyRef);

  @ViewChild(DocumentUploadDialogDirective, { static: true }) componentHost!: DocumentUploadDialogDirective;

  ngOnInit(): void {
    from(import('../../../cms/documents-upload/documents-upload.module').then(m => m.DocumentsUploadModule))
      .pipe(
        map(documentsUploadModule =>
          this.componentHost.viewContainerRef.createComponent(documentsUploadModule.documentsUploadComponent)
        ),
        tap(componentRef => {
          componentRef.instance.dialogData = {
            ...this.data,
            isLinkedFileUploadOnly: true,
            select: (link: string) => this.dialogRef.close(link)
          };
        })
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  close(): void {
    this.dialogRef.close();
  }
}
